/**
 * @deprecated Use `import { PlanTypesEnum } from '@ctct/domain-layer'` instead.
 */
const planTypesEnum = Object.freeze({
  email: 'GOOD',
  emailPlus: 'BETTER',
  emailBest: 'BEST',
  websiteBuilder: 'LITE',
  websiteBuilderV18: 'GROWTH',
  trial: 'TRIAL',
  proPackage: 'PRO',
  bronze: 'BRONZE',
  silver: 'SILVER',
  gold: 'GOLD',
  mobileFree: 'MOBILEFREE',
});

export const planNumberEnum = {
  Lite: 214,
  Standard: 215,
  Premium: 216,
};

export default planTypesEnum;
